import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const FocusBoundary = styled.div.attrs({
    role: "button",
    tabIndex: 0,
    "data-focus-boundary": true
}) `
  position: absolute;
`;
export const PortalFocusWrapper = (props) => {
    const { handleClose, children, closeLabel } = props;
    return (_jsxs(_Fragment, { children: [_jsx(FocusBoundary, { "aria-label": closeLabel, onFocus: handleClose, onClick: handleClose }), children, _jsx(FocusBoundary, { "aria-label": closeLabel, onFocus: handleClose, onClick: handleClose })] }));
};
